// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2jupJ","header":"ReportDetails_header__2r0zS","title":"ReportDetails_title__2x3Kw","left":"ReportDetails_left__1MlNT"};